import dotAccess from 'dot-access';

export const filterResource = (resource, name) => {
  const value = name && resource ? dotAccess.get(resource, name) : resource;
  return value !== undefined && value !== null ? value : '';

};



// WEBPACK FOOTER //
// ./src/main/functions/filterResource.js